<template>
  <div>
    <save-dialog
      title="Asignar chat a cliente"
      :show="showFiscal"
      @changeValue="$emit('changeValue', $event)"
      @save="saveFiscalId">
      <v-layout row wrap slot="content">
        <v-flex xs12>
          <v-text-field
          @input="resetErrors"
          v-model="customer.fiscal_id"
          v-validate="'required'"
          data-vv-name="fiscal_id"
          data-vv-as="RUT/DNI/CI"
          :error-messages="errors.collect('fiscal_id')"
          label="RUT/DNI/CI"
          color="black">
          </v-text-field>
        </v-flex>
      </v-layout>
    </save-dialog>
    <save-dialog
      title="Crear cliente"
      :show="showCustomer"
      @changeValue="closeModal"
      @save="saveCustomer">
      <v-layout row wrap slot="content">
        <v-flex xs12 md6 pr-4>
          <v-text-field
          @input="resetErrors"
          v-model="customer.first_name"
          v-validate="'required'"
          data-vv-name="first_name"
          data-vv-as="Nombre"
          :error-messages="errors.collect('first_name')"
          label="Nombre"
          color="black">
          </v-text-field>
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field
          @input="resetErrors" 
          v-model="customer.last_name"
          v-validate="'required'"
          data-vv-name="last_name"
          data-vv-as="Apellido"
          :error-messages="errors.collect('last_name')"
          label="Apellido"
          color="black">
          </v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
          @input="resetErrors" 
          v-model="customer.fiscal_id"
          v-validate="'required'"
          data-vv-name="rut"
          data-vv-as="RUT/DNI/CI"
          :error-messages="errors.collect('fiscal_id')"
          label="RUT/DNI/CI"
          color="black">
          </v-text-field>
        </v-flex>
        <v-flex xs12 md6 >
          <v-select
            v-model="customer.gender"
            data-vv-name="gender"
            data-vv-as="Genero"
            :error-messages="errors.collect('gender')"
            label="Genero"
            item-value="id"
            item-text="name"
            :items="genders"
            color="black">
          </v-select>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
          @input="resetErrors" 
          v-model="customer.account"
          data-vv-name="account"
          data-vv-as="Cuenta"
          :error-messages="errors.collect('account')"
          label="Cuenta"
          color="black">
          </v-text-field>
        </v-flex>
        <v-flex xs12 md6 >
          <v-menu
            ref="birthday"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="customer.birthday"
            transition="scale-transition"
            min-width="290px"
            lazy
            offset-y
            full-width>
            <v-text-field
            @input="resetErrors"
              slot="activator"
              placeholder="Fecha de nacimiento"
              :value="formatDate(customer.birthday, 'YYYY-MM-DD', 'DD/MM/YYYY')"
              prepend-icon="event"
              readonly
              color="black">
            </v-text-field>
            <v-date-picker
              v-model="customer.birthday"
              @input="$refs.birthday.save(customer.birthday)"
              locale="es"
              type="date"            
              color="k-orange-linear">
            </v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>
    </save-dialog>
    <v-dialog
      :value="showError"
      width="50%"
      @input="showError = $event"
      transition="dialog-transition">
      <v-card>
        <v-card-text class="pt-4 pb-4">
          <v-layout row wrap class="px-3">
            <v-flex xs12 class="text-xs-center mb-3">
              <v-icon
                slot="activator"
                class="f3-5em k-orange-linear-text"
              >
                fas fa-exclamation-triangle
              </v-icon>
            </v-flex>
            <v-flex xs12 class="text-xs-center my-2" v-if="!hasError">
              <p>El documento que ha ingresado no se encuentra registrado</p>
              <p>¿Desea crear un cliente?</p>
            </v-flex>
            <v-flex xs12 class="text-xs-center my-2" v-else>
              <p>{{ errorMessage }}</p>
            </v-flex>
            <v-flex xs12 class="text-xs-center">
              <v-btn depressed round @click="hideModal">
                <template v-if="!hasError">
                  CANCELAR
                </template>
                <template v-else>
                  ACEPTAR
                </template>
              </v-btn>
              <v-btn v-if="!hasError"
                class="k-orange-linear-text k-orange-linear-underline elevation-0"
                round
                @click="showCreate()"
              >
                CONTINUAR
              </v-btn>

            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SaveDialog from '@/components/global/SaveDialogV2';
import clearFormMixin from '@/mixins/clearForm';
import formatDateMixin from '@/mixins/formatDate';

export default {
  inject: ['$validator'],
  props: {
    showFiscal: {
      type: Boolean,
      default: false,
    },
    chatCenterId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    SaveDialog,
  },
  mixins: [
    clearFormMixin,
    formatDateMixin,
  ],
  data() {
    return {
      showError: false,
      hasError: false,
      errorMessage: '',
      showCustomer: false,
      showCreateCustomer: false,
      customer: {
        first_name: '',
        last_name: '',
        fiscal_id: '',
        gender: '',
        account: '',
        chatCenter: '',
        birthday: '',
      },
    };
  },
  computed: {
    ...mapGetters([
      'genders',
    ]),
    route() {
      return `/chats_center/${this.chatCenterId}`;
    },
  },
  methods: {
    saveFiscalId() {
      this.axios.patch(this.route, {
        fiscal_id: this.customer.fiscal_id,
      }).then(() => {
        this.closeModal();
      }).catch((error) => {
        if (error.response.status === 418) {
          this.hasError = false;
          this.errorMessage = '';
        } else {
          this.hasError = true;
          this.errorMessage = error.response.data.message;
        }
        this.showError = true;
      });
    },
    saveCustomer() {
      this.axios.post('customer', {
        ...this.customer,
      }).then(() => {
        this.closeModal();
      }).catch(() => {
        this.errorMessage = 'Ocurrió un error intente nuevamente';
        this.hasError = true;
        this.showError = true;
      });
    },
    hideModal() {
      this.hasError = false;
      this.errorMessage = '';
      this.showError = false;
    },
    resetErrors() {
      if (this.errors.any()) {
        this.errors.clear();
      }
    },
    showCreate() {
      this.showCustomer = true;
      this.$emit('changeValue', false);
      this.showError = false;
    },
    clear() {
      this.customer = {
        first_name: '',
        last_name: '',
        fiscal_id: '',
        gender: '',
        account: '',
        chatCenter: '',
        birthday: '',
      };
    },
    closeModal() {
      this.$emit('changeValue', false);
      this.showCustomer = false;
      this.clear();
    },
  },
  watch: {
    showFiscal(newVal) {
      this.customer.chatCenter = this.chatCenterId;
      if (!newVal && !this.showCustomer) {
        this.clear();
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/chat_center_v2/AssignDialog.vue